export default {
  title:
    "Delivery to your location: Amount needed to reach the minimum order value (Subtotal excl. delivery costs & tip)",
  description:
    "Sorry, you can't order yet. {{name}} has set a minimum order amount of {{threshold}} (excl. delivery costs)",
};
